import React, { useContext } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import AdminFooter from "../../components/Footers/AdminFooter";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Admin.css";
import { routes, routesGerenteFotografo } from "../../routes.js";
import { routesEmpresa } from "../../routes.js";
import { AuthContext } from "../../context/AuthContext";

const Admin = (props: any) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  const { selectTypeUser } = useContext(AuthContext);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document && document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent && mainContent.current) {
      //@ts-ignore
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  // const getRoutes = (routes: any) => {
  //   return routes.map((prop: any, key: number) => {
  //     if (prop.layout === "/admin") {
  //       return (
  //         // @ts-ignore
  //         <Route path={prop.path} element={prop.component} key={key} exact />
  //       );
  //     } else {
  //       return null;
  //     }
  //   });
  // };

  const getRoutes = (routes: any) => {
    return routes.flatMap((prop: any, key: number) => {
      if (prop.subMenu) {
        return prop.subMenu
          .filter((sub: any) => sub.layout === "/admin")
          .map((sub: any, subKey: number) => (
            <Route
              path={sub.path}
              element={sub.component}
              key={`${key}-${subKey}`}
            />
          ));
      } else if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };  

  return (
    <>
      <Sidebar
        {...props}
        routes={selectTypeUser === 1 ? routesEmpresa : selectTypeUser === 4 ? routesGerenteFotografo : routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../../assets/img/brand/logoAtt.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <Routes>
          {getRoutes(selectTypeUser === 1 ? routesEmpresa : selectTypeUser === 4 ? routesGerenteFotografo : routes)}
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;